import { useEffect, useState } from 'react';

interface ImageProps {
  name: string;
  alt: string;
  classes?: string;
  width: string;
  height: string;
}

function Image({ name, alt, classes, width, height }: ImageProps): React.JSX.Element {
  const [image, setImage] = useState('');

  useEffect((): void => {
    const importImage = async (): Promise<void> => {
      try {
        const images = import.meta.glob('../../images/*', { eager: true });
        const key = `../../images/${name}`;

        if (images[key]) {
          const imported = images[key];
          const src = (imported as any).default || imported;

          setImage(src);
        } else {
          console.warn(`Image not found: ${name}`);
        }
      } catch (error) {
        console.error('Error loading image', error);
      }
    };

    importImage();
  }, [name]);

  return !image ? (
    <div
      className={`placeholder ${classes}`}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        minWidth: `${width}px`,
      }}
    />
  ) : (
    <img
      className={classes}
      src={image}
      alt={alt}
      width={width}
      height={height}
    />
  );
}

export default Image;
